import React from "react";
import {Paper} from "@mui/material";

export function SeatingPlanStickyFilter({children}: {
    children: React.ReactNode,
}) {
    return (
        <Paper
            elevation={2}
            sx={{
                position: 'sticky',
                top: {xs: 56, sm: 64},
                zIndex: theme => theme.zIndex.appBar - 1,
                p: 2,
            }}
        >
            {children}
        </Paper>
    );
}
